import { Component, Input, OnInit } from '@angular/core';
import { DateFormat, SBDate } from '@sb/library/localization';
import { FormFieldDateComponent } from '../single/form-field-date.component';

@Component({
    selector: 'lib-date-selector',
    templateUrl: './date-selector.component.html',
    styleUrls: ['./date-selector.component.scss']
})
export class DateSelectorComponent extends FormFieldDateComponent implements OnInit {

    private _renderType: DateFormat = 'short';
    private _dateFormatPattern: string;

    @Input() hasHeader: boolean = true;
    @Input()
    set renderType(value: DateFormat) {
        this._renderType = value;
        switch (value) {
            case 'short' :
                this._dateFormatPattern = this._LocalizationService.ShortDatePattern;
                break;
            case 'long' :
                this._dateFormatPattern = this._LocalizationService.LongDatePattern;
                break;
            case 'yearmonth' :
                this._dateFormatPattern = this._LocalizationService.YearMonthPattern;
                break;
            default:
                this._dateFormatPattern = this._LocalizationService.ShortDatePattern;
                break;
        }
        this.viewControl.setValue(this._initialDate.Render(value));
    }

    private _initialDate: SBDate = SBDate.Today();
    @Input()
    set initialDate(value: SBDate) {
        if (value.totalMilliseconds !== this._initialDate.totalMilliseconds) {
            this._initialDate = value;
            this.viewControl.setValue(value.Render(this._renderType));
            this._datePicker?.setVal(this._initialDate.ToJSDate());
        }
    }

    constructor() {
        super();
        this._dateFormatPattern = this._LocalizationService.ShortDatePattern;
    }

    override ngOnInit() {
        super.ngOnInit();
        this.viewControl.setValue(this._initialDate.Render(this._renderType));
    }

    DateChangeEvent(change: any): void {
        const date = SBDate.FromJSDate(change.value);
        this._initialDate = date;
        this.viewControl.setValue(date.Render(this._renderType));
        this.change.emit(date);
    }

    SetDate(date: SBDate | null = null) {
        if (date) {
            this._datePicker?.setVal(date.ToJSDate());
            this._initialDate = date;
            this.viewControl.setValue(date.Render(this._renderType));
        } else {
            this._datePicker?.setVal(this._initialDate.ToJSDate());
        }
    }

    get dateFormatPattern(): string {
        return this._dateFormatPattern;
    }

}
